<style>

.date{
  border: 1px rgba(0,0,0,0) solid;
  padding: 10px;
  text-align: center;
}
.sel{
  border: 1px rgba(0,0,0,1) solid;
  background-color: rgba(0,0,0,0.7);
  color: white;
}

</style>

{#each allYears as item}
<div class="date {item == selY ? 'sel' : ''}" on:click="{ () => uSelY(item) }">{item}</div>
{/each}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let year = "YYYY";

let selY = 0;
let allYears = [];


import { onMount } from "svelte";
onMount(async () => {
  // must be at least 18 to sign up
  let curYear = new Date().getFullYear() - 18;
  allYears = [];
  for (let i = curYear; i >= (curYear - 82); i--) {
    allYears.push(i);
  }
});


$:{
  if (year) {
    setSelection();
  }
}


function setSelection() {
  if (year == "YYYY") return;
  selY = parseInt(year);
}


function uSelY(i) {
  selY = i;
  done();
}


function done() {
  if (selY != 0) year = selY;
  dispatch("changed");
}


</script>